/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useEffect, useState, useCallback, useRef } from 'react';
import { useLocation } from 'wouter';

import * as AppPropTypes from '../../lib/PropTypes';
import { getComponentFromName } from '../../lib/utils';

import { useModal } from '../../contexts/ModalsContext';
import CloseButton from '../buttons/Close';
import * as Modals from './index';

import styles from '../../../styles/modals/modal.module.scss';

const propTypes = {
    page: AppPropTypes.page,
    className: PropTypes.string,
};

const defaultProps = {
    page: null,
    className: null,
};

const Modal = ({ page, className }) => {
    const modalRef = useRef(null);

    const { modal, setModal } = useModal();
    const [loadedModal, setLoadedModal] = useState(null);
    const [pathname] = useLocation();

    const onClose = useCallback(() => {
        setModal(null);
    }, [setModal]);

    const ModalComponent = getComponentFromName(
        Modals,
        loadedModal !== null ? loadedModal.type : null,
        null,
    );
    const hasLoadedModal = loadedModal !== null && ModalComponent !== null;
    const visible = modal !== null;

    useEffect(() => {
        if (modal !== null) {
            document.body.style.overflow = 'hidden';
            setLoadedModal(modal);
        } else {
            document.body.style.overflow = '';
            setTimeout(() => {
                setLoadedModal(null);
            }, 500);
        }
        return () => {
            document.body.style.overflow = '';
        };
    }, [modal]);

    useEffect(() => {
        onClose();
    }, [pathname]);

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                    [styles.visible]: visible,
                },
            ])}
        >
            <div className={styles.wrapper} ref={modalRef}>
                <div className={styles.inner}>
                    {loadedModal !== null && loadedModal?.type !== 'timeline' ? (
                        <CloseButton className={styles.closeBtn} onClick={onClose} color="#fff" />
                    ) : null}
                    {hasLoadedModal ? (
                        <ModalComponent
                            className={styles.modal}
                            page={page}
                            {...loadedModal}
                            onClose={onClose}
                            visible={visible && loadedModal !== null}
                        />
                    ) : null}
                </div>
            </div>
            <div className={styles.lightBox} />
        </div>
    );
};

Modal.propTypes = propTypes;
Modal.defaultProps = defaultProps;

export default Modal;
